import './studiomovie/style';
import FormStructure from './studiomovie/form_structure';

export default FormStructure;